import {combineReducers} from "redux";
import loginReducer from "../reducer/loginReducer";


const rootred = combineReducers({
    loginReducer,
});


export default rootred